import { render, staticRenderFns } from "./mdAndA.vue?vue&type=template&id=c87c0e84&scoped=true"
import script from "./mdAndA.vue?vue&type=script&lang=js"
export * from "./mdAndA.vue?vue&type=script&lang=js"
import style0 from "./mdAndA.vue?vue&type=style&index=0&id=c87c0e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87c0e84",
  null
  
)

export default component.exports